import React, { useEffect, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { COOKIE_CONSENT } from '../../Utils/constants';

export const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', COOKIE_CONSENT.ACCEPTED);
    setOpen(false);
  };

  const handleDoNotAccept = () => {
    localStorage.setItem('cookie-consent', COOKIE_CONSENT.REJECTED);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleAccept}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{'Cookie Consent'}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          We use third-party cookies that help us analyze how you use this website, store your
          preferences, and provide the content that is relevant to you. You can opt out of
          these cookies by selecting &quot;Do Not Sell or Share My Personal Information&quot;
          below.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDoNotAccept} variant='text'>
          I Do Not Accept Cookies
        </Button>
        <Button onClick={handleAccept} variant='contained'>
          I Accept Cookies
        </Button>
      </DialogActions>
    </Dialog>
  );
};
